/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-05-23 12:17:58
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-13 14:48:44
 * @FilePath: /designcenter/src/api/modules/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IRes } from '@/types'
import { getApiRequest } from '@/utils'

const request = getApiRequest()
export function uploadFileService(data: FormData) {
  return request.post<IRes<string | null>>('/design/export/uploadTopologyFile', data)
}

interface IGetProjectInfo {
  projectId: number
  userId: number
  typeId: number
}

export function recordShareProject(data: IGetProjectInfo) {
  return request.post<IRes<string | null>>('/design/customer/recordShareProject', data)
}
